import { BsGripVertical } from "react-icons/bs";
import { GrNotes } from "react-icons/gr";

export default function AssignmentControlButtons(
) {
    return (
        <div>
            <BsGripVertical className="me-2 fs-3" />
            <GrNotes className="me-2 fs-3 text-success" />
        </div>
    )
                                                       
}